import React, { useState } from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { userLogin } from '../Services/Services';
import { removeToken, storeToken, storeResponse } from '../Services/LocalStorageService';
import './Login.css';
import AppLogo from '../Logo.png';

const Login = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await userLogin({
        email: formData.email,
        password: formData.password,
        com_name: "rto"
      });

      if (response.token) {
        // Clear any existing tokens and store new ones
        removeToken();
        storeToken(response.token);
        storeResponse(response.user);
        
        // Show success toast
        toast.success("Login Successful! 🎉", {
          duration: 3000,
          position: 'bottom-right',
          style: {
            background: '#1e293b',
            color: '#10b981',
            border: '1px solid #10b981',
            fontSize: '14px',
            padding: '16px',
          },
        });
        
        // Call the onLoginSuccess callback which will update state in App.js
        setTimeout(() => {
          if (onLoginSuccess) {
            onLoginSuccess();
          }
        }, 1000);
      } else {
        setError("Invalid Email or Password! ❌");
        toast.error("Login Failed! Invalid credentials", { 
          position: 'bottom-right',
          style: {
            background: '#1e293b',
            color: '#ef4444',
            border: '1px solid #ef4444',
          }
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      setError(err.response?.data?.message || "Server connection failed. Please try again.");
      toast.error("Login Failed! Server Error", { 
        position: 'bottom-right',
        style: {
          background: '#1e293b',
          color: '#ef4444',
          border: '1px solid #ef4444',
        }
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <Toaster />
      
      <div className="bg-overlay"></div>
      
      <div className="glass-container">
        <form className="login-form" onSubmit={handleSubmit}>
          
          {/* LOGO SECTION */}
          <div className="logo-wrapper" style={{ 
            textAlign: 'center', 
            marginBottom: '5px',
            width: '100%',
            overflow: 'hidden' 
          }}>
            <img 
              src={AppLogo} 
              alt="App Logo" 
              className="app-logo" 
              style={{
                maxWidth: '100%',
                height: '165px',
                width: '165px',
                display: 'block',
                margin: '0 auto',
                filter: 'brightness(1.4) contrast(1.2) drop-shadow(0 0 12px rgba(255,255,255,0.25))',
              }}
            />
          </div>

          {error && (
            <p style={{ 
              color: '#ff4d4d', 
              fontSize: '0.85rem', 
              marginBottom: '15px', 
              textAlign: 'center' 
            }}>
              {error}
            </p>
          )}

          <div className="input-field">
            <label htmlFor="email" style={{ 
              display: 'block', 
              marginBottom: '8px', 
              textAlign: 'left', 
              fontSize: '0.9rem', 
              color: '#fff' 
            }}>
              Email
            </label>
            <input 
              id="email"
              type="email" 
              name="email"
              placeholder="Enter Your Email"
              value={formData.email}
              onChange={handleChange}
              required 
              disabled={loading}
            />
          </div>

          <div className="input-field">
            <label htmlFor="password" style={{ 
              display: 'block', 
              marginBottom: '8px', 
              textAlign: 'left', 
              fontSize: '0.9rem', 
              color: '#fff' 
            }}>
              Password
            </label>
            <input 
              id="password"
              type="password" 
              name="password"
              placeholder="Enter Your Password"
              value={formData.password}
              onChange={handleChange}
              required 
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="submit-btn" 
            style={{ 
              marginTop: '15px',
              opacity: loading ? '0.7' : '1',
              cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%'
            }}
            disabled={loading}
          >
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                <div className="login-spinner"></div>
                Logging in...
              </span>
            ) : (
              'Login Now'
            )}
          </button>

          <div className="company-footer" style={{ marginTop: '30px', textAlign: 'center' }}>
            <p style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: '5px' }}>
              Developed By
            </p>
            <a 
              href="https://yashvitech.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="company-link"
              style={{
                color: '#38bdf8',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '5px'
              }}
            >
              Yashvitech IT Solution Pvt Ltd
              <FaExternalLinkAlt size={10} />
            </a>
          </div>
        </form>
      </div>

      {/* Add spinner styles if not already in your CSS */}
      <style>{`
        .login-spinner {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: loginSpin 0.8s linear infinite;
        }
        
        @keyframes loginSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Login;